<footer class="bg-[#012E26] text-white font-montserrat">
    <div class="container-fluid mx-auto py-12 px-4 xl:px-24">
        <div class="grid grid-cols-1 md:grid-cols-6 gap-4">

            <div>
                <h3 class="text-xl font-semibold mb-6 relative">
                    <span class="relative z-10">Admissions</span>
                    <span
                        class="absolute bottom-0 left-0 w-12 h-0.5 bg-[#b38b2a]"
                    ></span>
                </h3>
                <ul class="space-y-3">
                    <li>
                        <a
                            href="/admissions/overview"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Admission</span>
                        </a>
                    </li>
                    <li>
                        <a
                            href="/admissions/how-to-apply"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>How To Apply</span>
                        </a>
                    </li>
                    <li>
                        <a
                            href="/admissions/program-fee"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Program Fee</span>
                        </a>
                    </li>
                    <li>
                        <a
                            href="/admissions/scholarship"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Scholarship</span>
                        </a>
                    </li>
                    <li>
                        <a
                            href="/admissions/refund-policy"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Refund Policy</span>
                        </a>
                    </li>
                    <li>
                        <a
                            href="/admissions/lateral-entry-or-migration"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Lateral Entry</span>
                        </a>
                    </li>
                </ul>
            </div>

            <!-- Column 2: Other Links -->
            <div>
                <h3 class="text-xl font-semibold mb-6 relative">
                    <span class="relative z-10">Other Links</span>
                    <span
                        class="absolute bottom-0 left-0 w-12 h-0.5 bg-[#b38b2a]"
                    ></span>
                </h3>
                <ul class="space-y-3">
                    <li>
                        <a
                            href="/quick-links/image-gallery"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Image Gallery</span>
                        </a>
                    </li>
                    <li>
                        <a
                            href="/quick-links/video-gallery" target="_blank"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Video Gallery</span>
                        </a>
                    </li>
                    <li>
                        <a
                            href="quick-links/contact-us"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Contact Us</span>
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://samadhaan.ugc.ac.in/"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>UGC e samadhan</span>
                        </a>
                    </li>
                    <!--<li>
                        <a
                            href="/news"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>News</span>
                        </a>
                    </li>-->
                    <!--   <li>
                           <a
                               href="/media-coverage"
                               class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                           >
                               <i
                                   class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                               ></i>
                               <span>Media Coverage</span>
                           </a>
                       </li>-->
                </ul>
            </div>

            <!-- Column 3: Connect -->
            <div>
                <h3 class="text-xl font-semibold mb-6 relative">
                    <span class="relative z-10">Connect</span>
                    <span
                        class="absolute bottom-0 left-0 w-12 h-0.5 bg-[#b38b2a]"
                    ></span>
                </h3>
                <ul class="space-y-3">
                    <li>
                        <a
                            href="/about/leadership/chancellor"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Leadership</span>
                        </a>
                    </li>
                    <li>
                        <a
                            href="/about/faculty"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Faculties</span>
                        </a>
                    </li>
                    <!--<li>
                        <a
                            href="/about/work-at-arni"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Work At ARNI</span>
                        </a>
                    </li>-->
                    <li>
                        <a
                            href="/research/research-overview"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Research</span>
                        </a>
                    </li>
                    <!-- <li>
                         <a
                             href="/alumni"
                             class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                         >
                             <i
                                 class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                             ></i>
                             <span>Alumni</span>
                         </a>
                     </li>-->
                    <!--  <li>
                          <a
                              href="/international"
                              class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                          >
                              <i
                                  class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                              ></i>
                              <span>International</span>
                          </a>
                      </li>-->
                    <li>
                        <a
                            href="/blog"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Blog</span>
                        </a>
                    </li>
                </ul>
            </div>

            <!-- Column 4: Connect -->
            <div>
                <h3 class="text-xl font-semibold mb-6 relative">
                    <span class="relative z-10">Exams</span>
                    <span
                        class="absolute bottom-0 left-0 w-12 h-0.5 bg-[#b38b2a]"
                    ></span>
                </h3>
                <ul class="space-y-3">
                    <li>
                        <a
                            (click)="goToUrl(environment.examUrl)"
                            target="_blank"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors cursor-pointer"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Scholarship Examination</span>
                        </a>
                    </li>
                </ul>
            </div>

            <div>
                <h3 class="text-xl font-semibold mb-6 relative">
                    <span class="relative z-10">ERP</span>
                    <span
                        class="absolute bottom-0 left-0 w-12 h-0.5 bg-[#b38b2a]"
                    ></span>
                </h3>
                <ul class="space-y-3">
                    <li>
                        <a
                            href="https://admin.arni.in/"
                            target="_blank"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors cursor-pointer"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Employee Login</span>
                        </a>
                    </li>
                    <li>
                        <a
                           href="https://student.arni.in/"
                            target="_blank"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors cursor-pointer"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Student Login</span>
                        </a>
                    </li>
                </ul>
            </div>

            <!-- Column 5: Downloads -->
            <div>
                <h3 class="text-xl font-semibold mb-6 relative">
                    <span class="relative z-10">Downloads</span>
                    <span
                        class="absolute bottom-0 left-0 w-12 h-0.5 bg-[#b38b2a]"
                    ></span>
                </h3>
                <ul class="space-y-3 mb-6">
                    <li>
                        <a
                            href="/downloads/brochure"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Brochure</span>
                        </a>
                    </li>
                    <li>
                        <a
                            href="/downloads/registration-form"
                            class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                        >
                            <i
                                class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                            ></i>
                            <span>Registration Form</span>
                        </a>
                    </li>
                    <!-- <li>
                         <a
                             href="/downloads/guidelines"
                             class="flex items-center text-gray-300 hover:text-[#b38b2a] transition-colors"
                         >
                             <i
                                 class="fa fa-angle-right text-[#b38b2a] text-xs mr-2"
                             ></i>
                             <span>Guidelines</span>
                         </a>
                     </li>-->
                </ul>
                <h3 class="mt-4">Follow Us:</h3>
                <div class="flex space-x-3 mb-6">
                    <a
                        href="https://www.facebook.com/ARNI.Education/"
                        target="_blank"
                        class="w-10 h-10 rounded-full bg-[#3b5998] flex items-center justify-center hover:opacity-80 transition-opacity"
                    >
                        <i class="fab fa-facebook-f text-white my-auto"></i>
                    </a>
                    <a
                        href="https://x.com/ArniUniversity1?s=08"
                        target="_blank"
                        class="w-10 h-10 rounded-full bg-[#1da1f2] flex items-center justify-center hover:opacity-80 transition-opacity"
                    >
                        <i class="fab fa-twitter text-white my-auto"></i>
                    </a>
                    <a
                        href="https://www.instagram.com/arni.university/?utm_medium=copy_link"
                        target="_blank"
                        class="w-10 h-10 rounded-full bg-[#c32aa3] flex items-center justify-center hover:opacity-80 transition-opacity"
                    >
                        <i class="fab fa-instagram text-white my-auto"></i>
                    </a>
                    <a
                        href="https://api.whatsapp.com/send?phone=1234567890&lang=en"
                        target="_blank"
                        class="w-10 h-10 rounded-full bg-[#0a66c2] flex items-center justify-center hover:opacity-80 transition-opacity"
                    >
                        <i class="fab fa-whatsapp text-white my-auto"></i>
                    </a>
                    <a
                        href="https://www.youtube.com/watch?v=RSa3v7KV2h4"
                        target="_blank"
                        class="w-10 h-10 rounded-full bg-[#ff0000] flex items-center justify-center hover:opacity-80 transition-opacity"
                    >
                        <i class="fab fa-youtube text-white my-auto"></i>
                    </a>
                </div>

                <div class="flex items-start my-4 md:mb-0 aarni-font">
                    <i class="fa fa-map-marker-alt text-[#b38b2a] text-xl mr-3 mt-1"></i>
                    <div class="text-gray-300 text-md leading-5">
                        <p class="mb-2">ARNI University, (Kathgarh)</p>
                        <p class="mb-2">Tehsil Indora, Distt. Kangra</p>
                        <p class="mb-2">Himachal Pradesh - 176401</p>
                        <p>India</p>
                    </div>
                </div>

                <!--   &lt;!&ndash; Visitor Counter &ndash;&gt;
                   <h4 class="text-lg font-semibold mb-4">No. of Visitors</h4>
                   <div class="bg-[#102235] rounded p-2 inline-block">
                       <div class="flex">
                           &lt;!&ndash; Display individual digits of visitor count &ndash;&gt;
                           <ng-container
                               *ngFor="let digit of visitorCount.split('')"
                           >
                               <span
                                   class="w-7 h-8 bg-gradient-to-b from-[#ffd700] to-[#b8860b] text-black font-bold flex items-center justify-center rounded"
                                   >{{ digit }}</span
                               >
                           </ng-container>
                       </div>
                   </div>

                   &lt;!&ndash; Newsletter Subscription &ndash;&gt;
                   <h4 class="text-lg font-semibold mt-6 mb-4">
                       Subscribe Newsletter
                   </h4>
                   <div class="flex">
                       <input
                           #newsletterEmail
                           type="email"
                           placeholder="Email Address"
                           class="px-4 py-2 text-sm rounded-l-md w-full focus:outline-none text-black"
                       />
                       <button
                           (click)="subscribeNewsletter(newsletterEmail.value)"
                           class="bg-[#b38b2a] hover:bg-[#e67524] px-4 py-2 rounded-r-md text-white font-medium transition-colors"
                       >
                           <i class="fa fa-paper-plane"></i>
                       </button>
                   </div>-->
            </div>
        </div>
    </div>

    <!--  &lt;!&ndash; Location and Contact Bar &ndash;&gt;
      <div class="bg-[#09473c] py-4">
          <div class="container mx-auto px-4">
              <div class="flex flex-wrap justify-between items-center">
                  <div class="flex items-center mb-4 md:mb-0">
                      <i
                          class="fa fa-map-marker-alt text-[#b38b2a] text-xl mr-3"
                      ></i>
                      <p class="text-gray-300 text-sm">
                          ARNI University, (Kathgarh), Tehsil Indora, Distt.
                          Kangra, Himachal Pradesh - 176401, India
                      </p>
                  </div>
                  <div class="flex items-center mb-4 md:mb-0">
                      <i class="fa fa-phone-alt text-[#b38b2a] text-xl mr-3"></i>
                      <p class="text-gray-300 text-sm">+91-18008918962</p>
                  </div>
                  &lt;!&ndash;<div class="flex items-center">
                      <i class="fa fa-binoculars text-[#b38b2a] text-xl mr-3"></i>
                      <a href="/virtual-tour" class="text-gray-300 text-sm hover:text-[#b38b2a] transition-colors">Virtual Tour</a>
                  </div>&ndash;&gt;
              </div>
          </div>
      </div>-->

    <!-- Powered by Logo Section -->
    <div class="bg-[#012E26] py-3 border-t border-gray-800">
        <div class="container mx-auto px-4">
            <div class="flex justify-center sm:justify-end">
                <div class="flex items-center">
                    <span class="text-gray-400 text-sm mr-2 my-auto"
                    >Powered By</span
                    >
                    <a href="#" class="hover:opacity-80 transition-opacity">
                        <img
                            src="assets/img/logo/arni-updated-logo.png"
                            alt="ARNI Tech Logo"
                            class="h-8"
                            style="height: 55px"
                        />
                    </a>
                </div>
            </div>
        </div>
    </div>

    <!-- Copyright Section -->
    <div class="bg-[#09473c] py-4 border-t border-gray-800">
        <div class="container mx-auto px-4">
            <div class="flex flex-wrap justify-between items-center">
                <div class="text-gray-400 text-sm mb-4 md:mb-0">
                    © {{ currentYear }} ARNI University
                    <a
                        href="/disclaimer"
                        class="ml-4 hover:text-[#b38b2a] transition-colors"
                    >Disclaimer</a
                    >
                    <a
                        href="/privacy-policy"
                        class="ml-4 hover:text-[#b38b2a] transition-colors"
                    >Privacy Policy</a
                    >
                    <a
                        href="/terms-and-conditions"
                        class="ml-4 hover:text-[#b38b2a] transition-colors"
                    >Terms and Conditions</a
                    >
                </div>
                <div class="flex items-start flex-col sm:flex-row sm:space-x-4 sm:items-center">
                    <div class="text-gray-400 flex items-center text-sm">
                        <span class="font-semibold mr-2">National</span>
                        <span>+91-78-7685-9292</span>
                    </div>
                    <div class="text-gray-400 flex items-center text-sm">
                        <span class="font-semibold mr-2">International</span>
                        <span>+91-9418601409</span>
                    </div>
                    <!--<a href="/virtual-tour" class="text-gray-400 text-sm hover:text-[#b38b2a] transition-colors">
                        <i class="fa fa-binoculars mr-1"></i>
                        Virtual Tour
                    </a>-->
                </div>
            </div>
        </div>
    </div>
</footer>
